export const FETCH_ORGS_LITE = 'FETCH_ORGS_LITE' as const;
export const FETCH_ORGS_LITE_SUCCESS = 'FETCH_ORGS_LITE_SUCCESS' as const;
export const FETCH_ORGS_LITE_FAIL = 'FETCH_ORGS_LITE_FAIL' as const;
export const FETCH_ORGS_LITE_CANCEL = 'FETCH_ORGS_LITE_CANCEL' as const;
